import * as React from 'react';
import CountryService from '../services/CountryService';
import { currencyRoundFormat } from 'helpers/src/currency/currencyRoundFormat'; 

interface ICurrencyFormatterProps {
  price: number;
  bold?: boolean;
  className?: string;
  style?: any;
  freeAsWord?: boolean;
  currency?: GQL.ICurrency;
  decimals?: number;
}

const CurrencyFormatter = (props: ICurrencyFormatterProps) => {

  const { price, className, currency, decimals } = props;

  const code = currency 
    ? currency.value 
    : CountryService.GetInstance().currencyCode;
    
  const style = props.style ? props.style : {};

  const output = currencyRoundFormat(price, code, { decimals });

  return (
    <span
      className={className}
      style={props.bold ? { ...style, fontWeight: 'bold' } : { ...style }}
    >
      {output}
    </span>);

};

export default CurrencyFormatter;



// WEBPACK FOOTER //
// ./src/utils/CurrencyFormatter.tsx